import { Component, OnInit, ViewChild, Input, HostListener, ViewChildren, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ChartComponent, SeriesItemComponent, SeriesLabelsContentArgs, SeriesLabelsVisualArgs, SeriesVisualArgs } from '@progress/kendo-angular-charts';
import { SeriesLabels } from '@progress/kendo-angular-charts';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Router } from '@angular/router';
import { drawing, geometry, Group, Path, Rect } from '@progress/kendo-drawing';

@Component({
  selector: 'lib-ph-bhp-bar-chart',
  templateUrl: './ph-bhp-bar-chart.component.html',
  styleUrls: ['./ph-bhp-bar-chart.component.css']
})
export class PhBhpBarChartComponent implements OnInit {
  @ViewChild('chart') chart: ChartComponent;
  @ViewChild('legend') legend: ChartComponent;
  @ViewChildren('series') series: any;
  @Input() isAdjustableHeight = false;
  @Input() isDesktop = false;
  @Input() type = 'bar';
  @Input() maxDivisions = 6;
  @Input() maxBar = 6;
  @Input() showPercentageLabel = true;
  @Input() threshold: number = 10;
  @Input() isLitres: boolean = false;
  @Input() hideLegend: boolean = false;
  @Input() barLabelPosition: any = 'outsideEnd';
  @Input() isExportReport: boolean = false;
  @Input() dashboardReport: boolean = false;
  @Input() majorUnit: number = 0;
  @Output() onSeriesClick = new EventEmitter();
  ispPannable;
  // private chart: ChartComponent;

  toolTipSuffix = "%";
  fullTextArray: any;
  noDataFound: boolean = false;
  chartAnotherArra: Array<any> = [];
  fullText = [];
  font = "11.998px OpenSans-Regular";
  public chartOptions = {
    title: {
      text: "",
      position: "top",
      visible: false
    },
    legend: {
      text: "",
      position: "bottom",
      font: "9px roboto",
      visible: false,
      labels: {
        font: "9px roboto"
      }
    },
    seriesDefaults: {
      type: "column",
      area: {
        line: {
          style: "smooth"
        }
      },
      border: {
        width: 0,
        color: 'transparent',
        opacity: 0,
        dashType: 'solid'
      },
      visual: (e: SeriesVisualArgs) => {
        const colors = ["#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"];
        if (colors.includes(e.series.color)) {
          return e.createVisual();
        }

        const benchmarkColor = this.getSeriesColor(e.series.color);
          var left = e.rect.topLeft();
          var right = e.rect.topRight();
          var width = 5;
          var group = new drawing.Group();
          var index = 0;
          for (var x = left.x; x < right.x; x += width) {
            var currentWidth = width;
            if (x + width > right.x) {
              currentWidth = right.x - x;
            }

            var rect = new geometry.Rect([x, left.y], [currentWidth, e.rect.height()])
            var path = drawing.Path.fromRect(rect, { fill: { color: index % 2 == 0 ? benchmarkColor : "#FFFFFF" }, stroke: null });
            group.append(path);
            index = index + 1;
          }

          return group;
      }
    },
    series: [{
      name: [],
      data: [],//[70.6, 55, 35, 66, 47],
      color: "#001689",
      labels: {
        font: "9px OpenSans-Regular"
      }
    }],
    valueAxis: {
      min: 0,
      max: 100,
      majorUnit: this.majorUnit || 0,
      labels: {
        format: "{0}%",
      },
      title: {
        text: "",
        font: "9px OpenSans-Regular"
      },
      line: {
        visible: true
      },
      axisCrossingValue: 0
    },
    categoryAxis: {
      categories: [],// ['Placing a PVC', 'PLacing a PVC - KRINKO', 'Dressing change', 'Tracheostormy Suctioning', 'Placing Urinary Catheter'],
      majorGridLines: {
        visible: false
      },
      labels: {
        rotation: 'auto',
        font: "9px OpenSans-Regular"
      },
      maxDivisions: 10,
      rotation: 0
    },
    axisDefaults: {
      labels: {
        rotation: 'auto',
        font: "9px OpenSans-Regular",
      }
    },
    tooltip: {
      visible: false,
      format: "{0}%"
    }
  }

  seriesLabels: SeriesLabels = {
    visible: true,
    padding: 3,
    format: "{0}%",
    position: 'insideEnd',
    color: '#fff',
    //rotation: 270,
    background: '',
    //content :this.labelContent
  };
  item: any;
  isPannable: any;
  isZoomable: any;
  chartId: string;

  constructor(private layoutService: PHBHPLayoutPackageService, public router: Router) {
    this.getLabelPosition = this.getLabelPosition.bind(this);
    this.getLabelPositionNoPercent = this.getLabelPositionNoPercent.bind(this);
  }
  ngOnInit() {
    this.chartOptions.valueAxis.majorUnit = this.majorUnit;
    this.layoutService.kendoChart.subscribe(() => {
      this.closeTooltip();
    });
  }

  public labelContent(e: any): string {
    if (e.value == 0 || e.value == '0') {
      return '';
    }
    if (e.series && e.series.labels && e.series.labels.format) {
      var format = e.series.labels.format;
      return format.replace('{0}', e.value);
    } else {
      return e.value;
    }
  }

  isBenchmarkBar(color: string): boolean {
    return color.startsWith('url');
  }

  public getLabelPositionNoPercent(e: any): SeriesLabels {
    var sl: SeriesLabels = {
      visible: true,
      padding: 3,
      format: "{0}",
      position: 'outsideEnd',
      color: '#000',
      background: '',
      content: (e: SeriesLabelsContentArgs) => {
        if(e.value == null) return '';
        if (!e.value || e.value == 0 || e.value == '0') {
          // difference between 0% and no data. In web version always is 0% and can be in litres or %
          if(e.category == 'bef.pat.' || e.category == 'bef.aspet.' || e.category == 'aft.b.f.' || e.category == 'aft. pat.' || e.category == 'aft.p.sur.'){
            return '0';
          }
        }

        if(typeof e.value === 'number'){
          let value = parseFloat(e.value.toFixed(1));
          return `${value}`;
        }else{
          return e.value;
        }
      },
      font: this.isExportReport ? "6px Roboto" : "12px Roboto"

    };

    var sl2: SeriesLabels = {
      visible: true,
      padding: 3,
      format: "{0}",
      position: e.series.color.includes('benchmark') ? 'outsideEnd' : 'insideEnd',
      color: e.series.color.includes('benchmark') ? '#000' : '#ffff',
      background: '',
      content: (e: SeriesLabelsContentArgs) => {
        if(!e.value) return '';
        if(typeof e.value === 'number'){
          let value = parseFloat(e.value.toFixed(1));
          return `${value}`;
        }else{
          return e.value;
        }
      },
      font: this.isExportReport ? "6px Roboto" : "12px Roboto"
    };


    const sNoData = this.buildNoDataLabel(this.isExportReport ? '6px Roboto' : '10px Roboto', 7, -4);

    if(e.value == "NODATA"){
      return sNoData;
    }else{
      if (this.threshold) {
        return e.value < this.threshold ? sl : sl2;
      }
      else {
        return e.value < 10 ? sl : sl2;
      }
    }
  }

  public getLabelPosition(e: any): SeriesLabels {

    var sl: SeriesLabels = {
      visible: true,
      padding: 3,
      format: "{0}%",
      position: 'outsideEnd',
      color: '#000',
      background: '',
      content: (e: SeriesLabelsContentArgs) => {
        if(e.value == null) return '';
        if (!e.value || e.value == 0 || e.value == '0') {
          return '0%';
        }

        if(typeof e.value === 'number'){
          let value = parseFloat(e.value.toFixed(1));
          return `${value}%`;
        }else{
          return e.value;
        }
      },
      font: this.isExportReport ? "6px Roboto" : "12px Roboto"

    };

    var sl2: SeriesLabels = {
      visible: true,
      padding: 3,
      format: "{0}%",
      position: e.series.color.includes('benchmark') ? 'outsideEnd' : 'insideEnd',
      color: e.series.color.includes('benchmark') ? '#000' : '#ffff',
      background: '',
      content: (e: SeriesLabelsContentArgs) => {
        if(!e.value) return '';
        if(typeof e.value === 'number'){
          let value = parseFloat(e.value.toFixed(1));
          return `${value}%`;
        }else{
          return e.value;
        }
      },
      font: this.isExportReport ? "6px Roboto" : "12px Roboto"
    };

    const sNoData = this.buildNoDataLabel(this.isExportReport ? '6px Roboto' : '10px Roboto', 7, -4);

    if(e.value == "NODATA"){
      return sNoData;
    }else{
      if (this.threshold) {
        return e.value < this.threshold ? sl : sl2;
      }
      else {
        return e.value < 10 ? sl : sl2;
      }
    }
  }


  chartDatamani() {
    var self = this;
    self.fullText = [];
    self.chartAnotherArra = [];
    this.chartOptions.valueAxis.majorUnit = this.majorUnit;
    for (var category of this.chartOptions.categoryAxis.categories) {
      self.fullText.push(category);
      self.chartAnotherArra.push(this.splitText(category, this.isExportReport ? 30 : 20));
    };
  }

  splitText(text: string, maxLength: number): string {
    if (text.length <= maxLength) {
      return text;
    }

    const words = text.split(' ');
    let currentLine = '';
    let result = '';

    for (let i = 0; i < words.length; i++) {
      const word = words[i];
      const nextLine = currentLine + word + ' ';

      if (nextLine.length > maxLength) {

        if (/^[,.;:!?)"'\]}]+$/.test(word)) {
          result += currentLine.trim() + word + '\n';
          currentLine = '';
        } else {
          const lastWord = currentLine.trim();
          if (lastWord.length > 0 && /[,.;:!?('"{\[]+$/.test(lastWord)) {
            result += currentLine.trim() + '\n';
          } else {
            result += currentLine.trim() + '\n';
          }
          currentLine = word + ' ';
        }
      } else {
        currentLine = nextLine;
      }
    }

    result += currentLine.trim();
    return result;
  }

  exportImage(data) {
    return this.chart.exportImage(data)
  }
  exportSVG(data) {
    return this.chart.exportSVG(data)
  }
  exportVisual() {
    return this.chart.exportVisual()
  }

  onResize(event) {

    const winWidth = window.innerWidth;
    if (winWidth > 767 && winWidth < 1024) {
      this.maxDivisions = 6;
      this.maxBar = 6;
    } else if (winWidth >= 1024) {
      this.maxDivisions = 8;
      this.maxBar = 8;
    } else {
      this.maxDivisions = 3;
      this.maxBar = 3;
    }
  }

  closeTooltip() {
    this.chart.hideTooltip();
  }

  // @HostListener('window:scroll', ['$event'])
  //   scrollHandler(event) {
  //     this.closeTooltip();
  //   }


  // findTooltipText(truncatedText, points) {
  //
  //   var self = this;
  //   var toolTipText = '';
  //   self.fullText.forEach(function(itemtext){
  //       if(truncatedText.slice(0, 10) === itemtext.slice(0, 10)) {
  //         toolTipText=  itemtext;
  //       }
  //   });
  //   return toolTipText;
  // }


  findTooltipText(category, points) {
    if (points) {
      var point = points[0];
      var categoryIndex = point.categoryIndex;
      return this.fullText[categoryIndex];
    }

    if (category) {
      var self = this;
      var toolTipText = '';
      self.fullText.forEach(function (itemtext) {
        if (category.length <= 20) {
          if (category.slice(0, 10) === itemtext.slice(0, 10)) {
            toolTipText = itemtext;
          }
        }
        else {
          if (category.slice(0, category.length - 3) === itemtext.slice(0, category.length - 3)) {
            toolTipText = itemtext;
          }
        }
      });
      return toolTipText;
    }
  }

  internalToggleSerie(serie: any): void {
    var toToggleSerie = this.series.toArray()[serie.index];
    if (toToggleSerie) toToggleSerie.toggleVisibility();
  }

  toggleSerie(serie: any, index: number): void {
    var toToggleSerie = this.series.toArray()[index];
    if (toToggleSerie) {
      toToggleSerie.toggleVisibility();
      this.onSeriesClick.emit({ chartId: this.chartId, serie, index, visible: toToggleSerie.options.visible });
    }
  }

  isLegendItemActive(index: number): boolean {
    var serie = this.series ? this.series.toArray()[index] : null;
    if (!serie) return true;
    if (serie.options.visible === undefined || serie.options.visible) return true;
    else return false;
  }

  getColorImage(color: string): string {
    const colors = ["#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"];
    if (colors.includes(color)) {
      return color;
    }

    switch (color) {
      case 'url(#benchmark1)':
        return 'url(assets/ph-bhp-evaluation/benchmarks/benchmark-1.svg)'
      case 'url(#benchmark2)':
        return 'url(assets/ph-bhp-evaluation/benchmarks/benchmark-2.svg)'
      case 'url(#benchmark3)':
        return 'url(assets/ph-bhp-evaluation/benchmarks/benchmark-3.svg)'
      case 'url(#benchmark4)':
        return 'url(assets/ph-bhp-evaluation/benchmarks/benchmark-4.svg)'
      case 'url(#benchmark5)':
        return 'url(assets/ph-bhp-evaluation/benchmarks/benchmark-5.svg)'
      case 'url(#benchmark6)':
        return 'url(assets/ph-bhp-evaluation/benchmarks/benchmark-6.svg)'
    }
  }

  getBackgroundImage(color: string): string {
    const colors = ["#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"];
    if (colors.includes(color)) {
      return '';
    }

    switch (color) {
      case 'url(#benchmark1)':
        return 'url(assets/ph-bhp-evaluation/benchmarks/benchmark-1.svg)'
      case 'url(#benchmark2)':
        return 'url(assets/ph-bhp-evaluation/benchmarks/benchmark-2.svg)'
      case 'url(#benchmark3)':
        return 'url(assets/ph-bhp-evaluation/benchmarks/benchmark-3.svg)'
      case 'url(#benchmark4)':
        return 'url(assets/ph-bhp-evaluation/benchmarks/benchmark-4.svg)'
      case 'url(#benchmark5)':
        return 'url(assets/ph-bhp-evaluation/benchmarks/benchmark-5.svg)'
      case 'url(#benchmark6)':
        return 'url(assets/ph-bhp-evaluation/benchmarks/benchmark-6.svg)'
    }

    return color;
  }

  getSeriesColor(color: string): string {
    const colors = ["#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"];
    if (colors.includes(color)) {
      return color;
    }

    switch (color) {
      case 'url(#benchmark1)':
        return '#001689'
      case 'url(#benchmark2)':
        return '#40C4FF'
      case 'url(#benchmark3)':
        return '#9744FF'
      case 'url(#benchmark4)':
        return '#BF44B9'
      case 'url(#benchmark5)':
        return '#E57373'
      case 'url(#benchmark6)':
        return '#FFB300'
    }
  }

  getChartWidth() {
    var isDesktop = window.innerWidth > 767;
    if (this.isExportReport)
      return '93% !important';
    return this.dashboardReport || !isDesktop ? '100% !important' : '95% !important';
  }

  getChartHeight(categories: any[], series: any[]): string {
    if (this.isExportReport){
      const categoryCount = categories?.length || 1;
      const seriesCount = series?.length || 1;
      if (categoryCount === 0) return '100x';
      else if (categoryCount === 1) return '76px';

      let baseHeight = this.calculateBaseHeightForReportChat(seriesCount, categoryCount);

      return baseHeight + 'px';
    }
    var height = categories.length * (250 + 40 * Math.max(0, series.length - 5));
    if (height < 350) return '250px';
    return height + 'px';
  }

  private calculateBaseHeightForReportChat(seriesCount: number, categoryCount: number) {
    let baseHeight: number;
    if (seriesCount === 1) baseHeight = categoryCount * 42;
    else if (seriesCount <= 6) baseHeight = categoryCount * 50;
    else baseHeight = categoryCount * 62;
    return baseHeight;
  }

  private buildNoDataLabel(font: string, horizontalOffset: number, verticalOffset: number): SeriesLabels {
    return {
      visible: true,
      position: 'insideBase',
      color: '#2F2F2F',
      background: '',
      content: (_: SeriesLabelsContentArgs) => this.layoutService.translateText('EVALUATION.NO_DATA'),
      font,
      visual: this.createNoDataLabelVisual(horizontalOffset, verticalOffset)
};
  }

  private createNoDataLabelVisual(horizontalOffset: number, verticalOffset: number) {
    return (args: SeriesLabelsVisualArgs) => {
      const noDataText = this.layoutService.translateText('EVALUATION.NO_DATA');
      if (args.text !== noDataText) {
        return args.createVisual();
      }

      const rect = args.rect;
      const topLeft = rect.topLeft();
      const axisX = topLeft.x + rect.width();
      const centerY = topLeft.y + (rect.height() / 2) + verticalOffset;

      const position = new geometry.Point(axisX + horizontalOffset, centerY);
      const options: any = {
        font: args.options.font,
        fill: { color: (args.options.color as string) || '#2F2F2F' },
        textAlign: 'left',
        textBaseline: 'middle'
      };

      return new drawing.Text(noDataText, position, options);
    };
  }
};
